module.exports = __webpack_public_path__ + "static/img/class_27.7209ba41.jpg";